import React from "react";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";

interface BarChartProps {
  data: {
    name: string;
    value: any;
  }[];
  width?: number;
}

export default function ({ data = [], width = 600 }: BarChartProps) {
  const colors = ["#1f77b4", "#ff7f0e"];

  return (
    <BarChart
      width={width}
      height={width / 2}
      data={data}
      margin={{ top: 20, right: 30, left: -30, bottom: 5 }}
    >
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="name" />
      <YAxis />
      <Tooltip />
      <Bar dataKey="value" label={{ position: "top" }}>
        {data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={colors[index % 2]} />
        ))}
      </Bar>
    </BarChart>
  );
}
